import React, { useEffect, useContext, useState } from "react";
import { SuperSEO } from "react-super-seo";
import axios from "axios";
import { Card, Carousel, Col, ListGroup, Row, Spinner } from "react-bootstrap";
import PsContext from "../../../context";

import { ServiceUrl } from "../../../utils/serviceUrl";
import { DB_POSTFIX, getFileLiveUrl, LOADER_LOGO } from "../../../utils";

const PageContent = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);

  const deptId = props.match.params.id;
  const pageId = props.pageId.replace("#", "");

  const [sliders, setSliders] = useState([]);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    setSliders([]);
    setDataList([]);
    if (props.withSlider) loadSliders();
    loadPage();
  }, [props.location.pathname, props.pageId]);

  const loadSliders = () => {
    setLoader(true);
    setSliders([]);
    axios
      .get(
        ServiceUrl.DEPT.SLIDERS +
          "?academic_department=" +
          deptId +
          "&sadb=" +
          DB_POSTFIX
      )
      //.get(ServiceUrl.DEPT.SLIDERS + "?sadb=" + DB_POSTFIX)
      .then((res) => {
        if (res["data"].status == "1") {
          setSliders(res["data"].data);
        }
        setLoader(false);
      });
  };

  const loadPage = () => {
    setLoader(true);
    setDataList([]);
    axios
      .get(
        ServiceUrl.DEPT.PAGE +
          "?page_id=" +
          pageId +
          "&academic_department=" +
          deptId +
          "&sadb=" +
          DB_POSTFIX
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
        }
        setLoader(false);
      });
  };

  return (
    <>
      {loader && (
        <center className="py-5">
          <Spinner />
        </center>
      )}

      {sliders.length > 0 && (
        <div className="container">
          <Carousel>
            {sliders.map((item, i) => {
              return (
                <Carousel.Item>
                  <img
                    src={getFileLiveUrl(item.file_path)}
                    className="w-100"
                    style={{ height: "300px" }}
                  />
                </Carousel.Item>
              );
            })}
          </Carousel>
        </div>
      )}

      {dataList.id > 0 && (
        <div className="mt-4 ">
          {/* <h4 className="text-start text-black">{dataList.page_title}</h4> */}
          <div dangerouslySetInnerHTML={{ __html: dataList.page_content }} />
        </div>
      )}
    </>
  );
};

export default PageContent;
